import { logError } from '@utils/miscUtils';

export const verifyZipCode = async (zipCode: string) => {
	try {
		const response = await fetch(`/api/verify-zip-code/${zipCode}`, {
			method: 'GET',
		});

		if (!response.ok) {
			logError(`ERROR_VERIFYING_ZIPCODE: ${zipCode}, API returned ${response.status}`);
			return true; // Allow the zipcode to pass when API has issues
		}

		const data = (await response.json()) as { invalid: boolean };

		// Only return false if zipcode is explicitly invalid
		return !data.invalid;
	} catch (error) {
		if (error instanceof Error) {
			logError(`ERROR_VERIFYING_ZIPCODE: ${zipCode}, ${error.message}`);
		} else {
			logError(`ERROR_VERIFYING_ZIPCODE: ${zipCode}`);
		}
		// If there's an error verifying, allow the zipcode to pass through
		return true;
	}
};
